import { Card } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { ShipmentDetails } from '../types';
import { AddressCard } from './address-card';

interface Props {
  shipment: Pick<ShipmentDetails, 'contact_from' | 'customer_info' | 'contact_return' | 'contact_to'>;
}

export function Addresses({ shipment }: Props) {
  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.addresses')}</Card.Header>
      <Card.Grid css={{ width: '640px' }}>
        <AddressCard label="shipments.address.type.contact_from" address={shipment.contact_from?.address} />
        <AddressCard
          label="shipments.address.type.customer_info.contact"
          address={shipment.customer_info?.contact?.address}
          email={shipment.customer_info?.contact?.email}
          phone={shipment.customer_info?.contact?.phone}
        />
        <AddressCard label="shipments.address.type.contact_return" address={shipment.contact_return?.address} />
        <AddressCard label="shipments.address.type.contact_to" address={shipment.contact_to?.address} />
      </Card.Grid>
    </Card.Wrapper>
  );
}
